import { instance } from "./axios";


export const updateReceptionMeasurement = (payload, id) => {
  try {
    return instance.put(`/visit/reception/${id}`, payload);
  } catch (error) {
    throw error;
  }
}